angular.module('ikeweb.subscription').factory('subscriptionStateService', ['billingService', 'promiseFactory', 'subscriptionStateFactory',

    function(billingService, promiseFactory, subscriptionStateFactory) {

        var STATES = subscriptionStateFactory.STATES,
            clientStates = {};

        clientStates[STATES.TRIAL] = {
            isOnTrial: true,
            shouldSubscribe: false,
            shouldRenew: true
        };
        clientStates[STATES.BASIC] = {
            isOnTrial: false,
            shouldSubscribe: true,
            shouldRenew: false
        };
        clientStates[STATES.PREMIUM_YEARLY] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };
        clientStates[STATES.PREMIUM_MONTHLY] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };
        clientStates[STATES.CANCELED] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: true
        };
        clientStates[STATES.BASIC_CAN_TRIAL] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false,
            canTrial: true
        };
        clientStates[STATES.PENDING] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };

        function getState() {
            return promiseFactory.all([
                billingService.getActiveSubscription(),
                billingService.eligibleForTrial()
            ]).then(function(results) {
                return clientStates[subscriptionStateFactory.create(results[0], results[1])];
            });
        }

        return {
            getState: getState
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/subscription/subscription.state.service.js
// module id = 410
// module chunks = 0